import { destination } from './paired.js'

export default (
  element
) => {
  destination(element)
}
